import { loadConfig } from 'settings'
import { ensureUnpartitionedStorageAccessIfNeeded } from 'app/ui/EmbeddedStorageAccess'
import { isInIframe, isInSandboxedIframe } from 'app/utils/embedding'
import { preloadWorkerScriptsAsBlobs } from './features/common/utils/deckGlWorkers'

const boostrapApp = async () => {
  await loadConfig()

  const isViewer = window.location.pathname.startsWith('/viewer')
  const isOldViewerIframeAuthenticationMethod =
    isViewer && !window.location.search.includes('use-external-access-token')

  const needsUnpartitionedStorageAccess = isInIframe && isOldViewerIframeAuthenticationMethod

  if (needsUnpartitionedStorageAccess) {
    await ensureUnpartitionedStorageAccessIfNeeded()
  }

  if (isInSandboxedIframe()) {
    await preloadWorkerScriptsAsBlobs()
  }

  await import('./ReactApp')
}

boostrapApp()
